export const ACCESS_TOKEN_KEY = 'access-token';
export const AUTH_HEADER_KEYS = Object.freeze([
  'access-token',
  'client',
  'company_uuid',
  'expiry',
  'refresh-token',
  'uid',
]);
